export const commonConstants = {
  NATIONALITY_REQUEST: 'COMMON_NATIONALITY_REQUEST',
  NATIONALITY_SUCCESS: 'COMMON_NATIONALITY_SUCCESS',
  NATIONALITY_FAILURE: 'COMMON_NATIONALITY_FAILURE',

  GET_ORGANIZATION_REQUEST: 'COMMON_GET_ORGANIZATION_REQUEST',
  GET_ORGANIZATION_SUCCESS: 'COMMON_GET_ORGANIZATION_SUCCESS',
  GET_ORGANIZATION_FAILURE: 'COMMON_GET_ORGANIZATION_FAILURE',

  GET_ORG_BRANCH_REQUEST: 'COMMON_GET_ORG_BRANCH_REQUEST',
  GET_ORG_BRANCH_SUCCESS: 'COMMON_GET_ORG_BRANCH_SUCCESS',
  GET_ORG_BRANCH_FAILURE: 'COMMON_GET_ORG_BRANCH_FAILURE',

  // COUNTRY_REQUEST: 'COMMON_COUNTRY_REQUEST',
  // COUNTRY_SUCCESS: 'COMMON_COUNTRY_SUCCESS',
  // COUNTRY_FAILURE: 'COMMON_COUNTRY_FAILURE',

  CURRENCY_DETAIL_REQUEST: 'AMOUNT_CURRENCY_DETAIL_REQUEST',
  CURRENCY_DETAIL_SUCCESS: 'AMOUNT_CURRENCY_DETAIL_SUCCESS',
  CURRENCY_DETAIL_FAILURE: 'AMOUNT_CURRENCY_DETAIL_FAILURE',

  CURRENCY_REQUEST: 'AMOUNT_CURRENCY_REQUEST',
  CURRENCY_SUCCESS: 'AMOUNT_CURRENCY_SUCCESS',
  CURRENCY_FAILURE: 'AMOUNT_CURRENCY_FAILURE',

  GET_ID_TYPE_REQUEST: 'AMOUNT_GET_ID_TYPE_REQUEST',
  GET_ID_TYPE_SUCCESS: 'AMOUNT_GET_ID_TYPE_SUCCESS',
  GET_ID_TYPE_FAILURE: 'AMOUNT_GET_ID_TYPE_FAILURE',

  TRANSFER_REQUEST: 'AMOUNT_TRANSFER_REQUEST',
  TRANSFER_SUCCESS: 'AMOUNT_TRANSFER_SUCCESS',
  TRANSFER_FAILURE: 'AMOUNT_TRANSFER_FAILURE',

  RATES_REQUEST: 'AMOUNT_RATES_REQUEST',
  RATES_SUCCESS: 'AMOUNT_RATES_SUCCESS',
  RATES_FAILURE: 'AMOUNT_RATES_FAILURE',

  BENEFICAIRY_REQUEST: 'AMOUNT_BENEFICAIRY_REQUEST',
  BENEFICAIRY_SUCCESS: 'AMOUNT_BENEFICAIRY_SUCCESS',
  BENEFICAIRY_FAILURE: 'AMOUNT_BENEFICAIRY_FAILURE',

  GET_BENEFICAIRY_DETAILS_REQUEST: 'AMOUNT_GET_BENEFICAIRY_DETAILS_REQUEST',
  GET_BENEFICAIRY_DETAILS_SUCCESS: 'AMOUNT_GET_BENEFICAIRY_DETAILS_SUCCESS',
  GET_BENEFICAIRY_DETAILS_FAILURE: 'AMOUNT_GET_BENEFICAIRY_DETAILS_FAILURE',

  ADD_BENEFICIARY_UAE_REQUEST: 'PAYMENT_ADD_BENEFICIARY_UAE_REQUEST',
  ADD_BENEFICIARY_UAE_SUCCESS: 'PAYMENT_ADD_BENEFICIARY_UAE_SUCCESS',
  ADD_BENEFICIARY_UAE_FAILURE: 'PAYMENT_ADD_BENEFICIARY_UAE_FAILURE',

  TRANSCATION_REQUEST: 'AMOUNT_TRANSCATION_REQUEST',
  TRANSCATION_SUCCESS: 'AMOUNT_TRANSCATION_SUCCESS',
  TRANSCATION_FAILURE: 'AMOUNT_TRANSCATION_FAILURE',

  RECEIVED_CURRENCY: 'RECEIVED_CURRENCY',
  LAST_PAGE: 'LAST_PAGE',
  CLEAR_SERVICES: 'CLEAR_SERVICES',
  CLEAR_SERVICE_PROVIDER: 'CLEAR_SERVICE_PROVIDER',
  CLEAR_AGENT: 'CLEAR_AGENT',

  GET_RATE_CHARGE_REQUEST: 'AMOUNT_GET_RATE_CHARGE_REQUEST',
  GET_RATE_CHARGE_SUCCESS: 'AMOUNT_GET_RATE_CHARGE_SUCCESS',
  GET_RATE_CHARGE_FAILURE: 'AMOUNT_GET_RATE_CHARGE_FAILURE',

  CLEAR_RATE: 'CLEAR_RATE',
  CLEAR_PREVIOUS_TRANSFER_MESSAGE: 'CLEAR_PREVIOUS_TRANSFER_MESSAGE',
  CLEAR_PREVIOUS_CHANGE_PWD_MESSAGE: 'CLEAR_PREVIOUS_CHANGE_PWD_MESSAGE',

  GET_AGENT_DETAILS_REQUEST: 'GET_AGENT_DETAILS_REQUEST',
  GET_AGENT_DETAILS_SUCCESS: 'GET_AGENT_DETAILS_SUCCESS',
  GET_AGENT_DETAILS_FAILURE: 'GET_AGENT_DETAILS_FAILURE',

  GET_SERVICE_PROVIDER_REQUEST: 'GET_SERVICE_PROVIDER_REQUEST',
  GET_SERVICE_PROVIDER_SUCCESS: 'GET_SERVICE_PROVIDER_SUCCESS',
  GET_SERVICE_PROVIDER_FAILURE: 'GET_SERVICE_PROVIDER_FAILURE',

  GET_CUST_DETAIL_CODY_REQUEST: 'GET_CUST_DETAIL_CODY_REQUEST',
  GET_CUST_DETAIL_CODY_SUCCESS: 'GET_CUST_DETAIL_CODY_SUCCESS',
  GET_CUST_DETAIL_CODY_FAILURE: 'GET_CUST_DETAIL_CODY_FAILURE',

  COUNTRY_REQUEST: 'GET_COUNTRY_REQUEST',
  COUNTRY_SUCCESS: 'GET_COUNTRY_SUCCESS',
  COUNTRY_FAILURE: 'GET_COUNTRY_FAILURE',

  NEWSEVENT_REQUEST: 'GET_NEWSEVENT_REQUEST',
  NEWSEVENT_SUCCESS: 'GET_NEWSEVENT_SUCCESS',
  NEWSEVENT_FAILURE: 'GET_NEWSEVENT_FAILURE',

  SERVICES_REQUEST: 'GET_SERVICES_REQUEST',
  SERVICES_SUCCESS: 'GET_SERVICES_SUCCESS',
  SERVICES_FAILURE: 'GET_SERVICES_FAILURE',

  ServiceProvider_REQUEST: 'GET_ServiceProvider_REQUEST',
  ServiceProvider_SUCCESS: 'GET_ServiceProvider_SUCCESS',
  ServiceProvider_FAILURE: 'GET_ServiceProvider_FAILURE',

  SERVICEPROVIDER_REQUEST: 'SERVICE_PROVIDER_REQUEST',
  SERVICEPROVIDER_SUCCESS: 'SERVICE_PROVIDER_SUCCESS',
  SERVICEPROVIDER_FAILURE: 'SERVICE_PROVIDER_FAILURE',

  TYPEDETAILS_REQUEST: 'GET_TYPE_DETAILS_REQUEST',
  TYPEDETAILS_SUCCESS: 'GET_TYPE_DETAILS_SUCCESS',
  TYPEDETAILS_FAILURE: 'GET_TYPE_DETAILS_FAILURE',

  CURRENCTY_CAL_REQUEST: 'AMOUNT_CURRENCTY_CAL_REQUEST',
  CURRENCTY_CAL_SUCCESS: 'AMOUNT_CURRENCTY_CAL_SUCCESS',
  CURRENCTY_CAL_FAILURE: 'AMOUNT_CURRENCTY_CAL_FAILURE',

  CLEAR_CALC_CURR: 'CLEAR_CALC_CURR',

  BANK_BRANCH_REQUEST: 'GET_BANK_BRANCH_REQUEST',
  BANK_BRANCH_SUCCESS: 'GET_BANK_BRANCH_SUCCESS',
  BANK_BRANCH_FAILURE: 'GET_BANK_BRANCH_FAILURE',

  ALL_BANK_BRANCH_REQUEST: 'GET_ALL_BANK_BRANCH_REQUEST',
  ALL_BANK_BRANCH_SUCCESS: 'GET_ALL_BANK_BRANCH_SUCCESS',
  ALL_BANK_BRANCH_FAILURE: 'GET_ALL_BANK_BRANCH_FAILURE',

  ALL_BANK_REQUEST: 'GET_ALL_BANK_REQUEST',
  ALL_BANK_SUCCESS: 'GET_ALL_BANK_SUCCESS',
  ALL_BANK_FAILURE: 'GET_ALL_BANK_FAILURE',

  GET_RELATION_REQUEST: 'GET_RELATION_REQUEST',
  GET_RELATION_SUCCESS: 'GET_RELATION_SUCCESS',
  GET_RELATION_FAILURE: 'GET_RELATION_FAILURE',
};
